import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=58da933d&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=58da933d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da933d",
  null
  
)

export default component.exports